export default "__VITE_ASSET__DXM4gAkT__"